import { z } from 'zod'
import { ShippingMethod } from '@library/enums/shipping-method'
import { dateValueSchema } from '@library/models/date-value'
import { enumWithEmpty } from '@library/models/enum-with-empty'

/** 商務卡資訊 Common Schema */
export const businessCardCommonSchema = z.object({
  /** 前台申請日期 */
  applyTime: dateValueSchema,
  /** 會員卡號 */
  memberCardNumber: z.string(),
  /** 會員名 - 英文（同護照） */
  englishFirstName: z.string(),
  /** 會員姓氏 - 英文（同護照） */
  englishLastName: z.string(),
  /** 會員名稱 - 中文 */
  name: z.string(),
  /** 職稱 */
  title: z.string(),
  /** 卡籍效期 - 起日 */
  useStartTime: dateValueSchema,
  /** 卡籍效期 - 迄日 */
  useEndTime: dateValueSchema,
  /** 寄送方式 */
  shippingMethod: enumWithEmpty(ShippingMethod),
  /** 預設收件人 */
  receiver: z.string(),
  /** 指定代收人 - 代收人 */
  receiverAgent: z.string(),
  /** 電話國碼 */
  phoneArea: z.string(),
  /** 電話號碼 */
  phoneNo: z.string(),
  /** 郵遞區號 */
  postalCode: z.string(),
  /** 所在地 */
  location: z.string(),
  /** 城市 */
  city: z.string(),
  /** 鄉鎮市區 */
  optional: z.string(),
  /** 路名 */
  street: z.string(),
  /** 門牌號碼 */
  state: z.string()
})

/** 商務卡資訊 Common */
export interface BusinessCardCommon extends z.infer<
  typeof businessCardCommonSchema
> {}

export class BusinessCardCommon {
  constructor() {
    return {
      applyTime: '',
      memberCardNumber: '',
      englishFirstName: '',
      englishLastName: '',
      name: '',
      title: '',
      useStartTime: '',
      useEndTime: '',
      shippingMethod: ShippingMethod.DIRECT_MAIL,
      receiver: '',
      receiverAgent: '',
      phoneArea: '',
      phoneNo: '',
      postalCode: '',
      location: '',
      city: '',
      optional: '',
      street: '',
      state: ''
    }
  }
}
